var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoutGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.219,
    height: 21,
    viewBox: "0 0 19.219 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #707070;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: none;\r\n        stroke: #707070;\r\n        stroke-linecap: round;\r\n        stroke-miterlimit: 10;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12243",
    "data-name": "Group 12243",
    transform: "translate(-755 -120.5)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1824",
    "data-name": "Ellipse 1824",
    className: "cls-1",
    cx: 1.875,
    cy: 1.85,
    rx: 1.875,
    ry: 1.85,
    transform: "translate(762.625 129.607)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7139",
    "data-name": "Path 7139",
    className: "cls-2",
    d: "M13.731,16.2a9.11,9.11,0,1,1-7.641,0",
    transform: "translate(754.7 107.384)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1108",
    "data-name": "Line 1108",
    className: "cls-2",
    y2: 5.195,
    transform: "translate(764.5 121)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutGrey);
export default __webpack_public_path__ + "static/media/logout-grey.77d44036593c5d8a1362de53776e496e.svg";
export { ForwardRef as ReactComponent };